import { ServiciosPublicosIcon, TecnologiaIcon, SaludIcon, RecursosNaturalesIcon, OtrosIcon, OroYMaterialesPreciososIcon, MaterialesIndustrialesIcon, InfraestructurasIcon, FinanzasIcon, EnergiaIcon, EcologiaIcon, ConsumoIcon, ComunicacionesIcon, CapitalRiesgoIcon, BiotecnologiaIcon, AguaIcon, AgriculturaIcon, EnergiaAlternativaIcon } from '../../Products/sectorsIcons';
export var sectors = [{
  title: 'Agricultura',
  backgroundImage: AgriculturaIcon,
  link: 'Rv_sector_agricultura'
}, {
  title: 'Agua',
  backgroundImage: AguaIcon,
  link: 'Rv_sector_agua'
}, {
  title: 'Biotecnología',
  backgroundImage: BiotecnologiaIcon,
  link: 'Rv_sector_biotecnologia'
}, {
  title: 'Capital Riesgo',
  backgroundImage: CapitalRiesgoIcon,
  link: 'Rv_sector_capital_riesgo'
}, {
  title: 'Comunicaciones',
  backgroundImage: ComunicacionesIcon,
  link: 'Rv_sector_comunicaciones'
}, {
  title: 'Consumo',
  backgroundImage: ConsumoIcon,
  link: 'Rv_sector_consumo'
}, {
  title: 'Ecología',
  backgroundImage: EcologiaIcon,
  link: 'Rv_sector_ecologia'
}, {
  title: 'Energía',
  backgroundImage: EnergiaIcon,
  link: 'Rv_sector_energia'
}, {
  title: 'Energía Alternativa',
  backgroundImage: EnergiaAlternativaIcon,
  link: 'Rv_sector_energia_alternativa'
}, {
  title: 'Finanzas',
  backgroundImage: FinanzasIcon,
  link: 'Rv_sector_finanzas'
}, {
  title: 'Infraestructuras',
  backgroundImage: InfraestructurasIcon,
  link: 'Rv_sector_infraestructura'
}, {
  title: 'Materiales Industriales',
  backgroundImage: MaterialesIndustrialesIcon,
  link: 'Rv_sector_materiales_industriales'
}, {
  title: 'Oro y metales preciosos',
  backgroundImage: OroYMaterialesPreciososIcon,
  link: 'Rv_sector_oro_y_metales_preciosos'
}, {
  title: 'Otros',
  backgroundImage: OtrosIcon,
  link: 'Rv_sector_otros'
}, {
  title: 'Recursos Naturales',
  backgroundImage: RecursosNaturalesIcon,
  link: 'Rv_sector_recursos_naturales'
}, {
  title: 'Salud',
  backgroundImage: SaludIcon,
  link: 'Rv_sector_salud'
}, {
  title: 'Servicios Públicos',
  backgroundImage: ServiciosPublicosIcon,
  link: 'Rv_sector_servicios_publicos'
}, {
  title: 'Tecnología',
  backgroundImage: TecnologiaIcon,
  link: 'Rv_sector_tecnologia'
}];